import React from 'react'

import { datadogRum } from '@datadog/browser-rum'
import { Modal } from '@gousto-internal/citrus-react'

import type { RecipeQueryResponse } from '@library/api-menu-experience'
import type { RecipeUUID } from '@library/menu-service'

import { DetailContent } from 'routes/Menu/MenuExperience/Detail/DetailContent'

import css from './Detail.css'

type DetailProps = {
  uuid: RecipeUUID
  title: string
  showOverlay: boolean
  error: boolean
  loading: boolean
  recipe: RecipeQueryResponse | null
  position?: string
  reload: () => void
  onClose: () => void
  onSelectRecipe?: (recipeId: RecipeUUID) => void
  onRecipeDetailsClose?: () => void
  numPortions?: number
  onUpdatePortions: (numPortions: number) => void
  initialFlexPortionEditorOpen?: boolean
}

const getAllergenCount = (recipe: RecipeQueryResponse | null) => recipe?.allergens?.list.length ?? 0

export const Detail = ({
  uuid,
  title,
  showOverlay,
  error,
  loading,
  recipe,
  reload,
  onClose,
  onSelectRecipe,
  onRecipeDetailsClose,
  numPortions,
  onUpdatePortions,
  position,
  initialFlexPortionEditorOpen = false,
}: DetailProps) => (
  <Modal
    name="recipe-detail-modal"
    isOpen={showOverlay}
    onAfterOpen={() => {
      datadogRum.addAction('view_menu_recipe_detail', {
        recipe_id: recipe?.id,
        position,
        allergen_count: getAllergenCount(recipe),
      })
    }}
    onRequestClose={onClose}
    overlayClassName={css.overlay}
  >
    <DetailContent
      uuid={uuid}
      title={title}
      error={error}
      loading={loading}
      recipe={recipe}
      reload={reload}
      onClose={onClose}
      onSelectRecipe={onSelectRecipe}
      onRecipeDetailsClose={onRecipeDetailsClose}
      numPortions={numPortions}
      onUpdatePortions={onUpdatePortions}
      position={position}
      initialFlexPortionEditorOpen={initialFlexPortionEditorOpen}
    />
  </Modal>
)
